/**
 * Format currency for display (Indonesian Rupiah)
 */
export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

/**
 * Format distance with unit
 */
export const formatDistance = (km: number): string => {
  return `${km.toFixed(1)} km`;
};

/**
 * Format time in hours and minutes
 */
export const formatTime = (minutes: number, t: (key: any) => string): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;

  if (hours === 0) {
    return `${mins}min`;
  }

  return `${hours} ${t("unit-hours")} ${mins} min`;
};

/**
 * Format GPS speed indication
 */
export const formatSpeed = (distanceKm: number, timeMinutes: number): string => {
  if (timeMinutes === 0) return "0km/h";
  const speedKmPerHour = (distanceKm / timeMinutes) * 60;
  return `${Math.round(speedKmPerHour)} km/h`;
};
